import type { FC, PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

import { assert } from '../../../../guards'
import type { Nullable } from '../../../../types'

export type HeaderBlockPosition = 'left' | 'center' | 'right'

const HeaderBlockContext = createContext<Nullable<HeaderBlockPosition>>(null)

type HeaderBlockContextProviderProps = {
  position: HeaderBlockPosition
}

export const HeaderBlockContextProvider: FC<PropsWithChildren<HeaderBlockContextProviderProps>> = ({
  position,
  children,
}) => {
  return <HeaderBlockContext.Provider value={position}>{children}</HeaderBlockContext.Provider>
}

export const useHeaderBlockContext = (): HeaderBlockPosition => {
  const context = useContext(HeaderBlockContext)

  assert(context !== null, 'Trying to use HeaderBlockContext out of HeaderBlocks component')

  return context
}
